import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface IPurchaseListDetail {
    id: string;
    code: string;
    amountTotal?: string, // 7518
    contact?: string, // "陈"
    createTime?: string, // "2022-04-28 20:27:20"
    createUser?: string, // "陈彦晓"
    deleteFlag?: string, // 0
    deliveryTime?: string, // "2022-04-28 21:32:53"
    offerCode?: string, // "B-AAI-2205"
    payStatus?: string, // "pay-status.bill"
    phone?: string, // "121212"
    reckoner?: string, // "管理员"
    relevanceOrderId?: string, // "864725870641478fa6e566b2b66afb7d"
    saleCode?: string, // "YYCY-AAI-2202"
    settlementTime?: string, // "2022-04-28 21:32:49"
    shopCode?: string, // "SHOP-M-00000102"
    shopName?: string, // "云湖门店"
    status?: string, // "purchase.warehouse"
    supplierCode?: string, // "SUP-M-00000545"
    supplierId?: string, // "09e16d122facce20b74f12f1a3098f38"
    supplierName?: string, // "北京供应大大"
    typeNum?: string, // 2
    updateTime?: string, // "2022-04-28 21:32:55"
    updateUser?: string, // "陈彦晓"
    currencyCode?: string, // "陈彦晓"
    currency?: string, // "陈彦晓"
}

//新增
export interface IPurchaseListInsert extends IPurchaseListDetail { }

//编辑
export interface IPurchaseListUpdate extends IPurchaseListInsert {
    id: string;
}

//搜索条件
export interface IPurchaseListSearchFields { }

export interface IPurchaseListSearch extends IPurchaseListSearchFields, ISearchPage { }

export interface IStatistics { num: number, amount: number }


class PurchaseListService {
    async page(searchVo: IPurchaseListSearch, config: object = {}) {
        const apiUrl = "/gtm/standingBooking/purchaseListPage";
        return await httpRequest.post<IPage<IPurchaseListDetail>>(apiUrl, searchVo, config);
    }
    async total(searchVo: IPurchaseListSearch, config: object = {}) {
        const apiUrl = "/gtm/standingBooking/purchaseListPage/total";
        return await httpRequest.post<IStatistics>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: IPurchaseListSearch) {
        const appPageUrl = "/gtm/standingBooking/purchaseListPage/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/sale/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

}

export const purchaseListService = new PurchaseListService();
